"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var constants_1 = require("../../utils/theme/colors/constants");
exports.Heading = function (props) {
    var variant = props.variant;
    switch (variant) {
        case 'h1':
            return react_1.default.createElement(StyledH1, tslib_1.__assign({}, props));
        case 'h2':
            return react_1.default.createElement(StyledH2, tslib_1.__assign({}, props));
        case 'h3':
            return react_1.default.createElement(StyledH3, tslib_1.__assign({}, props));
        case 'h4':
            return react_1.default.createElement(StyledH4, tslib_1.__assign({}, props));
        default:
            return react_1.default.createElement(StyledH4, tslib_1.__assign({}, props));
    }
};
var StyledH1 = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 300;\n  font-size: 3rem;\n  line-height: 3.6rem;\n"], ["\n  color: ",
    ";\n  font-family: ", ";\n  font-weight: 300;\n  font-size: 3rem;\n  line-height: 3.6rem;\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color === 'inverted'
        ? constants_1.white
        : color === 'secondary'
            ? theme.colors.aqua[700]
            : theme.colors.NTDarkGrey[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoLight;
});
var StyledH2 = styled_components_1.default(StyledH1)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: 2.4rem;\n  line-height: 3rem;\n"], ["\n  font-size: 2.4rem;\n  line-height: 3rem;\n"])));
var StyledH3 = styled_components_1.default.h3(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 1.8rem;\n  line-height: 2.4rem;\n"], ["\n  color: ",
    ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 1.8rem;\n  line-height: 2.4rem;\n"])), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color === 'inverted'
        ? constants_1.white
        : color === 'secondary'
            ? theme.colors.aqua[700]
            : theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var StyledH4 = styled_components_1.default(StyledH3)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-size: 1.5rem;\n  line-height: 2rem;\n"], ["\n  font-size: 1.5rem;\n  line-height: 2rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
